import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStatePhysicalIssueForm extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['comments', 'physicalIssue'];
  }

  static get styles() {
    return [...super.styles, css`
      bn-form-field {
        --bn-form-field-min-height: 20vh;
        width: 80%;
        margin: 0 1em;
        --textarea-resize: vertical;
      }
    `];
  }

  render() {
    return html`
      <div class="flex col physical-issue-form">
        <h2>Please describe the state of the device</h2>
        <bn-form-field
          type="textarea"
          @input="${this._onInput}"
          .value="${this.data.comments}"
        ></bn-form-field>
        ${this.renderSubmit()}
      </div>
    `;
  }

  _onInput(e) {
    this.data.comments = e.target.input.value;
    this.stateHasData = this.data.comments.trim().length > 0;
    this.data.physicalIssue = this.stateHasData;
  }
}

window.customElements.define('bin-issue-state-physical-issue-form', BinIssueStatePhysicalIssueForm);
